// extracted by mini-css-extract-plugin
module.exports = {"legendParentWrapper":"RoleLegend_legendParentWrapper__3BG2q","legendParent":"RoleLegend_legendParent__1HH8n"};